<template>
  <div class="table-viewer-widget column full-height full-width">
    <div v-html="tableHtml" class="content row col full-width" />
      <div style="flex:0 0 8px" />
      <q-separator />
      <div style="flex:0 0 15px" />
      <div class="row wrap-pagination">
        <q-pagination
            v-model="state.tableIndex"
            :max="tableHtmls.length"
          />
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  setup() {
  },
  props: ['tableHtmls'],
  data: function () {
    return {
      state: {
        tableIndex: 1
      }
    }
  },
  computed: {
    tableHtml: function () {
      const Vue = this
      return Vue.tableHtmls.length > 0 ? Vue.tableHtmls[Vue.state.tableIndex - 1] : '<span style="color:#666666;">구조 분석 결과가 없습니다.</span>'
    }
  },
  watch: {
    tableHtmls: function () {
      const Vue = this
      Vue.state.tableIndex = 1
    }
  },
  async mounted () {
    /*
    const Vue = this
    Vue.tableHtmls = [
      '<table><tbody><tr><td Colspan=3 >발 급 번 호</td><td Rowspan=3  Colspan=5 >표준재무제표증명<br/>□ 개인 ■ 법인</td><td Rowspan=2 >처 리 기 간</td></tr><tr><td Rowspan=2  Colspan=3 >0853-850-3939-328</td></tr><tr><td>즉 시</td></tr><tr><td Colspan=2 >상 호 ( 법 인 명 )</td><td Colspan=4 >(재) 파라다이스복지재단</td><td Colspan=2 >사 업 자 등 록 번 호</td><td>203-82-32922</td></tr><tr><td Colspan=2 >성 명 ( 대 표 자 )</td><td Colspan=4 >최윤정</td><td Colspan=2 >주민(법인)등록번호</td><td>110122-*******</td></tr><tr><td Colspan=2 >업 태</td><td Colspan=7 >비영리</td></tr><tr><td Colspan=2 >종 목</td><td Colspan=7 >장애인복지사업</td></tr><tr><td Colspan=2 >주 소 ( 본 점 )</td><td Colspan=7 >서울특별시 중구 동호로 268, 3층(장충동2가, 파라다이스빌딩)</td></tr><tr><td Colspan=2 >사 업 연 도</td><td Colspan=3 >2018.01.01<br/>- 2018.12.31</td><td Colspan=2 >첨 부 서 류 명</td><td Colspan=2 >표준대차대조표<br/>표준손익계산서<br/>부속명세서</td></tr><tr><td Colspan=2 >신 고 구 분</td><td Colspan=3 >정기 신고</td><td Colspan=2 >신 고 일</td><td Colspan=2 >2019. 03. 25</td></tr><tr><td Rowspan=5  Colspan=9 >붙임의 표준재무제표는 과세표준 신고시<br/>세무서에 제출한 표준재무제표와 같음을 증명합니다.<br/>2019년 5월 2일<br/>중부세무서장<br/>(인)</td></tr></tbody></table>',
      '<table>3434</table>'
    ]
    */
  }
})
</script>


<style scoped>
.table-viewer-widget { 
  padding: 0px;
}
.table-viewer-widget > .content {
  overflow:auto;
  padding: 15px 15px;
  align-items: center;
  justify-content: center;
}
.table-viewer-widget > .content ::v-deep table, ::v-deep td {
  border: 1px solid black;
  border-collapse: collapse;
  font-size: 12px;
}
.table-viewer-widget > .wrap-pagination {
  padding: 0px 15px 15px 15px;
  align-items: center;
  justify-content: center;
}
</style>